import React from 'react';
import { Box, Button } from '@razorpay/blade/components';
import NoResultsView from 'components/Fnf/ReleaseNetpay/NoResultsVIew';

export const ReportEmptyState = ({
  hasGeneratedReport,
  isRealTime,
  onRefresh,
  isRefreshing,
}: {
  hasGeneratedReport: boolean;
  isRealTime: boolean;
  onRefresh: () => void;
  isRefreshing: boolean;
}) => {
  if (!hasGeneratedReport) {
    return (
      <Box paddingY="spacing.10">
        <NoResultsView
          boxProps={{
            maxWidth: '400px',
            margin: 'auto',
          }}
          title="No report generated yet"
          description={
            "To generate a report, please select the required options from the dropdown and click on the 'Generate New' button"
          }
        />
      </Box>
    );
  }

  return (
    <Box paddingY="spacing.10">
      <NoResultsView
        title="No results found"
        description={isRealTime ? 'Automatically refreshing report for new data' : ''}
        actions={
          isRealTime ? null : (
            <Button onClick={onRefresh} isLoading={isRefreshing}>
              Refresh
            </Button>
          )
        }
      />
    </Box>
  );
};
